const enRuntimeTranslations: Record<string, string> = {};

export default enRuntimeTranslations;
